import { useState, useEffect } from 'react';
import EditAdtrAuthorization from './editAdtrAuthorization';
import Spinner from 'react-bootstrap/Spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import BaseService from '../../../services/BaseService';
import DataGrid from '../../GenericComponents/DataGrid';
import { Column } from 'primereact/column';
import CommonService from "../../../services/CommonService";

const SearchResultContainer = (props) => {
  const [editAdtrAuths, setEditAdtrAuths] = useState(false);
  const [selectedAdtrAuthInfo, setSelectedAdtrAuthInfo] = useState([]);
  const {adtrId, fiscalYrEndDate, cdiacNumber} = props;
  const [adtrAuths, setAdtrAuths] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  let tableType = "Normal";

  const viewEditFormatter = (row) => {
    return (
      <div style={{
        textAlign: "center",
        lineHeight: "normal"
      }}>
        <FontAwesomeIcon icon={faPencilAlt} className="custom-icon" onClick={(e)=>onRowClick(e, row)}/> 
      </div>
    );
  }
  const onRowClick = (e, row) => {
    // e.preventDefault();
    setSelectedAdtrAuthInfo(row);
    setEditAdtrAuths(true);
  }

  //get adtr authorizations when Finalsale or adtr changes to refesh that adtr authorizatin edit list
  const getAdtrAuthsByAdtrId = () => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getAdtrAuthorizations",
      hdrStruct: null,
      queryParam: null,
      reqData: {
          "adtrId": adtrId,
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setAdtrAuths(result.data.responses[key]);
        });
        setIsLoading(false);
      });
  }

  useEffect(() => {
    if (adtrId) {
      getAdtrAuthsByAdtrId();
    }
    // eslint-disable-next-line
  }, [adtrId]);

  const columns = [{
    dataField: 'authorizationName',
    text: 'Authorization Name',
    sort: true,
  }, {
    dataField: 'authorizationDate',
    text: 'Authorization Date',
    sort: true,
    formatter: (row)=> CommonService.dateFormatter(row.authorizationDate),
  }, {
    dataField: 'beginAmt',
    text: 'Begin Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.beginAmt),
  }, {
    dataField: 'duringAmt',
    text: 'During Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.duringAmt),
  }, {
    dataField: 'authorityReducedAmt',
    text: 'Authority Reduced Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.authorityReducedAmt),
  }, {
    dataField: 'authorityReplenishAmt',
    text: 'Authority Replenish Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.authorityReplenishAmt),
  }, {
    dataField: 'lapsedAmt',
    text: 'Lapsed Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.lapsedAmt),
  }, {
    dataField: "",
    text: "Action",
    formatter: viewEditFormatter,
  }
  ];

  const handleModalClose = () => {
    setEditAdtrAuths(false);
    getAdtrAuthsByAdtrId();
  }


  return (
    <>
      <hr/>
      {isLoading && <Spinner animation="border" variant="primary" />}
      <div className="form">
        <h2>Search Result: </h2>
        <DataGrid
            title="Annual Debt Transparency Reports Authorizations"
            dataSource={adtrAuths}
            sortField='adtrAuthorizationId'
            searchToolTip="Use the search feature to quickly retrieve the system code values"
            emptyDataMessage='No data available to display'
            >
            {columns.map((column, i) => {
                return (
                <Column 
                key={i}
                field={column.dataField}
                header={column.text}
                sortable={column.sort} 
                body={column.formatter}
                hidden={column.hidden}
                />)
                }) 
            } 
        </DataGrid>
      </div>
      {editAdtrAuths && <EditAdtrAuthorization onModalClose={() => handleModalClose()} adtrAuthInfo={selectedAdtrAuthInfo} fiscalYrEndDate={fiscalYrEndDate} cdiacNumber={cdiacNumber} tableType={tableType} />}
    </>
  )
}

export default SearchResultContainer
